import axios from 'axios'
import throttle from 'client/common/throttle'

const USER_INPUT_DELAY = 400

const getRequestOptions = ipAddress => ({ headers: { ip: ipAddress } })

export const removeSpecialChars = term => term.replace(/[^0-9a-zA-Z:,\s]+/g, '')

export const createSuggestionsActions = successType => {
  let lastTerm = ''

  const fetchSuggestions = ({ host, format, lang, term, ipAddress, dispatch }) =>
    axios
      .get(`${host}/search-service/rest/v3/${format}/${lang}/suggestions?term=${term}`, getRequestOptions(ipAddress))
      .then(resp => {
        dispatch({
          type: successType,
          suggestions: resp.data.data,
          softContentSuggestions: resp.data.contentData
        })
        return resp
      })

  const onSuggestionsChange =
    ({ format, lang, dispatch }) =>
    term => {
      const ipAddress = window?.__LAYOUT_NEXT_STATE__?.ip ?? ''
      const termWithNoSpecialChars = removeSpecialChars(term)
      if (termWithNoSpecialChars === lastTerm) return
      lastTerm = termWithNoSpecialChars
      if (term === '' || +term?.length <= 2) {
        dispatch({ type: successType, suggestions: [] })
        return
      }
      const { origin } = new URL(global.document.location.href)
      const { SEARCH_SERVICE_HOST, MODE } = process.env
      const host = MODE === 'test' && SEARCH_SERVICE_HOST ? `http://${SEARCH_SERVICE_HOST}` : origin

      return throttle(
        () => fetchSuggestions({ host, format, lang, term: termWithNoSpecialChars, ipAddress, dispatch }),
        USER_INPUT_DELAY
      )
    }

  return { onSuggestionsChange }
}
